import { render, staticRenderFns } from "./oss-upload.vue?vue&type=template&id=71c8fc34&"
import script from "./oss-upload.vue?vue&type=script&lang=js&"
export * from "./oss-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports